import { useMemo } from "react";
import { useAllTaskTypes } from "../../task-management/services/useTaskTypes";
import {
  FilterValue,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { FilterConfig } from "../../task-management/types/TaskType";
import { TASK_TYPE_ID } from "../constants/filterIds";

type FilterConfigResult = {
  hasConfig: boolean; // true if task type has filters_config defined (even if empty)
  config: FilterConfig | null; // the specific filter config, or null
};

export function useTaskTypeFilterConfig(
  filterId: string,
  filterValues: FilterValue[]
): FilterConfigResult {
  const { data: taskTypes } = useAllTaskTypes();

  return useMemo(() => {
    const selectedTaskTypeFilter = filterValues.find(
      (f) => f.filterId === TASK_TYPE_ID
    );

    if (!selectedTaskTypeFilter || !taskTypes) {
      return { hasConfig: false, config: null };
    }

    const selectedTaskTypeName = (selectedTaskTypeFilter as StringFilterValue)
      ?.value;
    const taskType = taskTypes.find((tt) => tt.name === selectedTaskTypeName);

    // If task type doesn't have filters_config field, use existing logic
    if (
      !taskType ||
      taskType.filters_config === undefined ||
      taskType.filters_config === null ||
      !Array.isArray(taskType.filters_config)
    ) {
      return { hasConfig: false, config: null };
    }

    // Task type has filters_config (even if empty array)
    const config =
      taskType.filters_config.find((fc) => fc.id === filterId) || null;
    return { hasConfig: true, config };
  }, [filterId, filterValues, taskTypes]);
}
